/**************************************************
 CONTROLLER: deleteItemMemberModalController
**************************************************/
(function(){
    // add the controller
    SUGApp.controller('deleteItemMemberModalController', deleteItemMemberModalController);

    deleteItemMemberModalController.$inject = [ '$scope','$modalInstance','$q','SUGUtilities','errorService','signupPageService','modalInfo','itemmember'];
    function deleteItemMemberModalController(    $scope,  $modalInstance, $q,  util,  errorService, signupPageService,  modalInfo, itemmember ){

        $scope.isProcessing = false;
        $scope.notifycomment = '';
        $scope.modalInfo = modalInfo;
        $scope.itemmember = itemmember;
        $scope.isPaymentPending = (itemmember.status.toLowerCase() === 'paymentpending');        
        $scope.commentLabel = '';
        $scope.frmDisableField = false;

        /* View Specific Strings */
        $scope.strings = {
            modalTitle: 'Are you sure?',
            slotmsg: 'You are about to delete the following:',
            noUndo: 'This sign up will be permanently removed. There is no undo.',            
            errors:   {
                errorsPleaseCorrect:  'This sign up could not be deleted for the following reason:'
            },
            paymentPendingWarning: {
                type: 'warning',
                text: '<strong>Important Notice:</strong> A payment is pending for this item. Deleting this item will not cancel or refund a payment once the payment is processed. If you did not complete payment, you can delete the pending item(s).',
                dismissable: false,
                show: true
            },
            buttonLabel: 'Yes, Delete'
        };

        //init error service
        $scope.es = errorService.newInstance();
        $scope.es.init();
        $scope.es.clearErrors();

        /* Tooltip vars */
        $scope.popTrig = 'mouseenter';
        $scope.popPlacement = 'top';
        $scope.popDelay = 300;

        /**
         * Handler for the processing state.
         * @param {Boolean} blnProcessing - whether or not the form is processing
         */
        var setProcessing = function( blnProcessing ){
            $scope.isProcessing = blnProcessing;
            disableForm(blnProcessing);
            if( blnProcessing ){
                util.showLoading('processing');
            }
        };

        /**
         * Manage disabling the form
         * @param {Boolean} blnDisabled - whether or not to disable the form
         */
        var disableForm = function (blnDisabled) {
            $scope.frmDisableField = blnDisabled;
        };


        var deleteItemMember = function() {
            setProcessing(true);
            var payload = {
                listid: $scope.modalInfo.listid, 
                itemmemberid: $scope.itemmember.itemmemberid,
                notify: $scope.modalInfo.notify,
                notifycomment: $scope.notifycomment
            };
            signupPageService.deleteItemMember(payload)
                .then(function(response){
                    if (util.ajaxResultInvalid(response)) {
                        // invalid response, show error
                        var errMsg = util.getAjaxResponseMessage(response);
                        $scope.es.setError( 'deleteItemMember', errMsg );                        
                    }else{
                        $modalInstance.close({slotitemid: $scope.modalInfo.slotitemid, itemmemberid:$scope.itemmember.itemmemberid});
                    }
                    setProcessing(false);
            });
        };

        /**
         * Function to kick off any initilization steps, such as data loading and setting defaults
         */
        var init = function(){
            $scope.commentLabel = "Notification will be sent to the sign up administrator (" + $scope.modalInfo.contactName + ") with the following comment:";
        };

        /**
         * Returns true if the quantity should be displayed
         */
        $scope.showQty = function () {
            return $scope.itemmember.myqty > 1;
        };

        /**
         * close the modal
         */
        $scope.dismiss = function () {
            $modalInstance.dismiss(false);
        };

        /**
         * Event handler when success button is clicked.
         */
        $scope.ok = function () {            
            deleteItemMember();
        };

        init();
    }
}());